import React from 'react'
import { Account } from '../authorizationbox/accountbox/Account'
import './form.css'

function Form() {
  return (
    <div className='login-signup'>
        <Account />
    </div>
  )
}

export default Form